import { useEffect, useRef } from 'react';

import { addEventListener } from '../utils/dom';

export function useGlobalListener<
  T extends Document | Window | null,
  M extends T extends Document ? DocumentEventMap : WindowEventMap,
  K extends keyof M,
>(type: K, target: T, listener: (event: M[K]) => void, options?: boolean | AddEventListenerOptions): void {
  const listenerRef = useRef<(event: M[K]) => void>(listener);
  const optionsRef = useRef<boolean | AddEventListenerOptions | undefined>(options);

  useEffect(() => {
    listenerRef.current = listener;
  }, [listener]);

  useEffect(() => {
    if (!target) {
      return;
    }

    return addEventListener(
      // @ts-ignore
      target,
      type,
      (e: M[K]) => {
        listenerRef.current(e);
      },
      optionsRef.current
    );
  }, [type, target]);
}
